<template>
  <div style="height:330px" v-if="show">
    <div style="width:100%" ref="column" class="column"></div>
  </div>
</template>
<script>
export default {
  props: {
    show: Boolean,
    // 数据 数组
    data: {
      type: Object
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      my_chart: ""
    };
  },
  watch: {
    data: {
      handler(val, oldval) {
        this.render();
      },
      deep: true
    },
    show: {
      handler(val, oldval) {
        if (val) {
          this.$nextTick(() => {
            let dom = this.$refs.column;
            this.my_chart = this.$echart.init(dom);
            this.render();
          });

          //   setTimeout(() => {
          //       console.log(this.$refs.column);

          //     this.render();
          //   }, 300);
        }
      }
    }
  },
  methods: {
    render() {
      let obj = {
        title: {
          left: "25",
          top: "5",
          text: this.title
        },
        tooltip: {
          trigger: "axis"
        },
        color:['#FF6E09','#00A1FF'],
        legend: {
          data: ["月新增客户量", "月转化客户量"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ]
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: "月新增客户量",
            type: "line",
            stack: "总量",
            data: this.data.addUserCount,
            lineStyle:{
                normal:{
                    color:'#FF6E09'
                }
            }
          },
          {
            name: "月转化客户量",
            type: "line",
            stack: "总量",
            data: this.data.conversionCount,
            lineStyle:{
                normal:{
                    color:'#00A1FF'
                }
            }
          }
        ]
      };
      if (this.my_chart) {
        this.my_chart.setOption(obj);
        this.$func.addwindowsonresize(this.my_chart.resize);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.column {
    padding-top: 30px;
  height: 300px;
  width: 1000%;
}
</style>
